import { render, staticRenderFns } from "./FornecedorVarejoNovaExtensao.vue?vue&type=template&id=1329027e&"
import script from "./FornecedorVarejoNovaExtensao.vue?vue&type=script&lang=js&"
export * from "./FornecedorVarejoNovaExtensao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VSelect})
